/**
 * Controller: ProgramsCombosCreateConfigureAddModal
 */
angular.module('acme.view.application.programs.combos.create.configure.addModal.controllers', [])
.controller('ProgramsCombosCreateConfigureAddModalController', [ '$scope', '$uibModalInstance', 'templatesList', 'selectedTemplatesList', function ($scope, $uibModalInstance, templatesList, selectedTemplatesList) {

    $scope.errors = [];

    $scope.templates = [];
    $scope.selectedTemplates = [];

    $scope.model = {
      selected: {}
    };

    $scope.init = function() {
      $scope.templates = templatesList;
      $scope.selectedTemplatesList = selectedTemplatesList;
      $scope.restore();
    };

    $scope.restore = function() {
      var i, ii;

      if ($scope.selectedTemplatesList instanceof Array) {
        console.log('ProgramsCombosCreateConfigureAddModalController::restore', $scope.selectedTemplatesList);
        for (i=0,ii=$scope.selectedTemplatesList.length;i<ii;i++) {
          if ($scope.selectedTemplatesList[i].id) {
            $scope.model.selected[$scope.selectedTemplatesList[i].id] = true;
          }
        }
      }
    };

    $scope.hasErrors = function() {
      return ($scope.errors.length > 0);
    };

    $scope.done = function() {
      $scope.success();
    };

    $scope.cancel = function () {
      $uibModalInstance.dismiss('cancel');
    };

    $scope.success = function () {
      $uibModalInstance.close($scope.model.selected);
    };

    $scope.init();

}]);